var Bavaria = "バイエルン";
var Berlin = "ベルリン";
var Brandenburg = "ブランデンブルク";
var Bremen = "ブレーメン";
var Hamburg = "ハンブルク";
var Hesse = "ヘッセン";
var Saarland = "ザールラント";
var Saxony = "ザクセン";
var Thuringia = "テューリンゲン";
var DEStates = {
	"Baden-Wuerttemberg": "バーデン・ヴュルテンベルク",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "メクレンブルク・フォアポンメルン",
	"Lower Saxony": "ニーダーザクセン",
	"North Rhine-Westphalia": "ノルトライン・ヴェストファーレン",
	"Rhineland-Palatinate": "ラインラント・プファルツ",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "ザクセン・アンハルト",
	"Schleswig-Holstein": "シュレスヴィヒ・ホルシュタイン",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
